import type { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { cx } from '@/modules/common/helpers/classNames';
import type { ICardHudConfig } from '../../../../helpers';
import { type ILevelItem, LevelState } from '../../helpers';
import { CardHud } from './components/CardHud';
import { ScLevelCard } from './styled';

interface ILevelCardProps extends ILevelItem {
  namespace: string;
  cardHud: ICardHudConfig;
  isSelected: boolean;
  isLast: boolean;
  onClaim: (id: string) => void;
  onSelect: (id: string) => void;
}

export const LevelCard: FC<ILevelCardProps> = ({
  id,
  state,
  image,
  progress,
  progressLabelKey,
  reward,
  rewardLabelKey,
  rewardSuffixKey,
  glowColor,
  glowEndOpacity,
  cardHud,
  namespace,
  isSelected,
  isLast,
  onClaim,
  onSelect,
}) => {
  const { t } = useTranslation(namespace);
  const isIssued = state === LevelState.Issued;
  const isClickable = state !== LevelState.Locked;

  const handleClaim = (event: MouseEvent) => {
    event.stopPropagation();
    onClaim(id);
  };

  return (
    <ScLevelCard
      $glowColor={glowColor}
      $glowEndOpacity={glowEndOpacity}
      className={cx(state, isSelected && 'selected', isLast && 'last')}
      onClick={isClickable ? () => onSelect(id) : undefined}
    >
      <ImageComponent
        alt="reward"
        className="level-img"
        height={132}
        src={image}
        width={132}
      />

      {isIssued ? (
        <button className="cardClaimBtn" onClick={handleClaim} type="button">
          {t('missionLevels.card.claim')}
        </button>
      ) : (
        <CardHud
          cardHud={cardHud}
          namespace={namespace}
          progress={progress}
          progressLabelKey={progressLabelKey}
          reward={reward}
          rewardLabelKey={rewardLabelKey}
          rewardSuffixKey={rewardSuffixKey}
          state={state}
        />
      )}
    </ScLevelCard>
  );
};
